import { useNavigate } from "react-router-dom";
import { parseAPIErrorResponse } from "melco-shared-logic";
import { useLogin } from "../../hooks/login/useLogin";
import { useEffect, useState } from "react";
import { DisplayErrors } from "../helper/DisplayErrors";
export type DirectLoginWithoutPasswordValueType = {
  password: string;
};

type DirectLoginWithoutPasswordProps = {
  view_id: string | undefined;
  access_token: string | null;
};

export const DirectLoginWithoutPassword: React.FC<
  DirectLoginWithoutPasswordProps
> = ({ view_id, access_token }) => {
  const navigate = useNavigate();
  const login = useLogin();
  const [errors, setErrors] = useState<any[]>();

  const onSubmit = async () => {
    try {
      const loginResponse = await login({
        password: "",
        view_id,
        access_token,
      });
      if (loginResponse) {
        navigate("/view", {
          state: {
            password: "",
            view_id,
            access_token,
            apiResponse: loginResponse,
          },
        });
      }
    } catch (error) {
      const apiErrors = await parseAPIErrorResponse(error);

      setErrors(apiErrors);
    }
  };

  // Use useEffect to trigger onSubmit when the component is mounted
  useEffect(() => {
    onSubmit();
  }, []); // Dependency array ensures this runs only once

  return (
    <>{errors && errors.length > 0 && <DisplayErrors errors={errors} />}</>
  );
};
